import { render, staticRenderFns } from "./SurveyServiceFeeList.vue?vue&type=template&id=40c04666&scoped=true&"
import script from "./SurveyServiceFeeList.vue?vue&type=script&lang=js&"
export * from "./SurveyServiceFeeList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyServiceFeeList.vue?vue&type=style&index=0&id=40c04666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c04666",
  null
  
)

export default component.exports